import { BaseOrganizationEndpoints } from "./base";

export type DemoDataScope =
  | "users"
  | "floors"
  | "resources"
  | "amenities"
  | "workplace_requests"
  | "bookings"
  | "visits"
  | "pages";

export interface DemoDataOverrides {
  users: number;
  floorsPerOffice: number;
  resourcesPerFloor: number;
  amenitiesPerResource: number;
  ticketCategories: number;
  ticketTypes: number;
  tickets: number;
  approvalTickets: number;
  bookings: number;
  visits: number;
  pages: number;
}

export interface DemoDataGeneratePayload {
  scenario: string;
  scopes: DemoDataScope[];
  officeIds: string[];
  overrides: DemoDataOverrides;
  aiEnabled: boolean;
  aiPrompt: string;
}

export interface DemoDataWipePayload {
  scopes: DemoDataScope[];
}

const BASE_PATH = "/v1/dev/demo-data";

// DemoDataClient calls the dev-only, Tactic-staff-gated demo-data endpoints.
// Both stream Server-Sent Events, so they return the raw Response for the
// caller to consume the body.
export class DemoDataClient extends BaseOrganizationEndpoints {
  generate(payload: DemoDataGeneratePayload): Promise<Response> {
    return this.requestStream("POST", `${BASE_PATH}/generate`, payload);
  }

  wipe(payload: DemoDataWipePayload): Promise<Response> {
    return this.requestStream("POST", `${BASE_PATH}/wipe`, payload);
  }
}
